import {
	facebookPageUrl,
	instagramPageUrl,
	threadsPageUrl,
} from '#fysio/core/consts/socialMediaPages';
import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';

const items: SubHeaderMenuItemType[] = [];

items.push({
	icon: 'fa-facebook',
	text: 'Facebook',
	to: {
		title: 'Fysio Hier Facebook',
		url: facebookPageUrl,
		newTab: true,
	},
});

items.push({
	icon: 'fa-instagram',
	text: 'Instagram',
	to: {
		title: 'Fysio Hier Instagram',
		url: instagramPageUrl,
		newTab: true,
	},
});

items.push({
	icon: 'fa-threads',
	text: 'Threads',
	to: {
		title: 'Fysio Hier Threads',
		url: threadsPageUrl,
		newTab: true,
	},
});

export default items;
